<template>
    <transition name="el-fade-in-linear">
        <div v-show="showMain" class="transition-box">
            <div id="formblock">
                <el-form label-position="top" label-width="80px" :model="searchForm">
                    <el-row :gutter="30">
                        <el-col :span="5">
                            <el-form-item label="公司代號">
                                <el-input v-model="searchForm.COMP_ID"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="群組/角色代號">
                                <el-input v-model="searchForm.ROLE_ID"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="群組/角色名稱">
                                <el-input v-model="searchForm.ROLE_NAME"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="使用狀態">
                                <el-select v-model="searchForm.ACT_FG" style="width:100%;">
                                    <el-option label="全部" value=""></el-option>
                                    <el-option label="啟用" value="Y"></el-option>
                                    <el-option label="禁用" value="N"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <el-row type="flex" justify="center">
                    <el-col :span="6" style="margin-top:auto;margin-bottom:auto;">
                        <el-button style="width: 100%" type="primary" @click="onSearch" v-show="store.getters.check_auth('SEARCH')">Search</el-button>
                    </el-col>
                </el-row>
            </div>
            <div id="datablock">
                <el-row type="flex" justify="end">
                    <el-button type="primary" round plain @click="onAddClick()" v-show="store.getters.check_auth('ADD')">新增</el-button>
                </el-row>

                <div ref="table" style="margin-top:10px;"></div>
            </div>
        </div>
    </transition>

    <!-- 新增/編輯 角色資料-->
    <el-dialog :title="dialogTitle" width="500px" v-model="dialogFormVisible"
               @opened="onDialogOpen" center label-width="" :lock-scroll="false" :close-on-click-modal="false">
        <el-form :model="form" :rules="rules" ref="formRef" :inline-message="true" label-position="top">
            <el-row>
                <el-col>
                    <el-form-item label="公司代號" prop="COMP_ID">
                        <el-input v-model="form.COMP_ID" :disabled="IDdisabled" maxlength="100"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <el-form-item label="角色代號" prop="ROLE_ID">
                        <el-input v-model="form.ROLE_ID" :disabled="IDdisabled" maxlength="10"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <el-form-item label="角色名稱" prop="ROLE_CHI_NAME">
                        <el-input v-model="form.ROLE_CHI_NAME" maxlength="10"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="7">
                    <el-form-item label="狀態" prop="ACT_FG">
                        <el-select v-model="form.ACT_FG" style="width:100%;">
                            <el-option label="啟用中" value="Y"></el-option>
                            <el-option label="停用中" value="N"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="7" :offset="1">
                    <el-form-item label="開放公開" prop="PUBLIC_FG">
                        <el-select v-model="form.PUBLIC_FG" style="width:100%;">
                            <el-option label="Yes" value="Y"></el-option>
                            <el-option label="No" value="N"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8" :offset="1">
                    <el-form-item label="顯示排序" prop="DSP_ORD">
                        <el-input v-model="form.DSP_ORD" maxlength="3"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <el-form-item label="備註說明" prop="REMARKS">
                        <el-input v-model="form.REMARKS" type="textarea" :rows="3" maxlength="200"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="5" v-show="addOrEdit=='edit'">
                <el-col :span="3" style="text-align:center">
                    Creator
                </el-col>
                <el-col :span="9">
                    {{form.CREATE_USER}}<br />
                    {{form.CREATE_TIME}}
                </el-col>
                <el-col :span="3" style="text-align:center">
                    Editor
                </el-col>
                <el-col :span="9">
                    {{form.EDIT_USER}}<br />
                    {{form.EDIT_TIME}}
                </el-col>
            </el-row>
        </el-form>
        <template #footer class="dialog-footer">
            <el-button type="info" @click="dialogFormVisible = false" style="width: 150px;">取消</el-button>
            <el-button type="primary" @click="onSubmit('form')" style="width: 150px;">存檔</el-button>
        </template>
    </el-dialog>

    <!-- 角色權限 -->
    <transition name="el-fade-in-linear">
        <div v-show="showSetting" class="transition-box">
            <div id="formblock">
                <el-row>
                    <el-col :span="20">
                        <el-descriptions title="">
                            <el-descriptions-item label="角色名稱">{{setForm.ROLE_CHI_NAME}}</el-descriptions-item>
                        </el-descriptions>
                    </el-col>
                    <el-col :span="4">
                        <el-button type="primary" round plain style="float: right;" @click="onCopyClick">複製</el-button>
                    </el-col>
                </el-row>

                <div ref="table_set"></div>

                <el-row type="flex" justify="center" style="margin-top:10px;">
                    <el-button @click="onBack()">不儲存 / 回上頁</el-button>
                    <el-button @click="onSetSubmit()">儲存</el-button>
                </el-row>
            </div>
        </div>
    </transition>
</template>

<script setup>
    import { ref, reactive, onBeforeMount, onMounted, nextTick } from 'vue';
    import { TabulatorFull as Tabulator } from 'tabulator-tables'; //import Tabulator library
    import { ElMessage, ElMessageBox } from 'element-plus'
    import $api from '@/utils/axios'
    import { useStore } from "vuex";
    // import search from 'core-js/library/fn/symbol/search';
    const store = useStore();

    const showMain = ref(true);//顯示主頁面
    const showSetting = ref(false);//顯示設定頁面
    const dialogTitle = ref('');//角色資料dialog標題
    const dialogFormVisible = ref(false);//顯示角色資料dialog
    const IDdisabled = ref(false);//編輯時ID狀態
    const Roledisabled = ref(false); //公司角色不是門店時才可編輯
    const addOrEdit = ref('');
    const formRef = ref(null);
    const formData = ref(null);

    const compOptions = ref([]);

    const searchForm = reactive({
        COMP_ID: '',
        ROLE_ID: '',
        ROLE_NAME: '',
        ACT_FG: ''
    });

    const form = ref({
        COMP_ID: '',
        ROLE_ID: '',
        ROLE_CHI_NAME: '',
        ACT_FG: 'Y',
        PUBLIC_FG: 'Y',
        DSP_ORD: '',
        REMARKS: '',
        CREATE_USER: '',
        CREATE_TIME: '',
        EDIT_USER: '',
        EDIT_TIME: ''
    });

    const setForm = ref({
        COMP_ID: '',
        ROLE_ID: '',
        ROLE_CHI_NAME: '',
        ROLE_ENG_NAME: ''
    });

    const rules = reactive({
        COMP_ID: [{ required: true, message: '請輸入公司代號', trigger: 'blur' }],
        ROLE_ID: [{ required: true, message: '請輸入角色代號', trigger: 'blur' }],
        ROLE_CHI_NAME: [{ required: true, message: '請輸入角色名稱', trigger: 'blur' }],
        ACT_FG: [{ required: true, message: '請選擇狀態', trigger: 'blur' }],
        PUBLIC_FG: [{ required: true, message: '請選擇開放公用', trigger: 'blur' }],
    });



    const table = ref(null); //reference to your table element
    const tabulator = ref(null); //variable to hold your table
    const table_set = ref(null);
    const tabulator_set = ref(null);

    const onLoadTable = () => {
        $api.GET('/api/BaseRole/GetTableData', searchForm
        ).then((response) => {
            tabulator.value.setData(response);
        });
    }

    const onLoadSetTable = () => {
        $api.GET('/api/SysFuncRole/GetTableData', {
            COMP_ID: setForm.value.COMP_ID, ROLE_ID: setForm.value.ROLE_ID
        }).then((response) => {
            //console.log(response);
            tabulator_set.value.setData(response);
        });
    }
    const onSearch = () => {
        onLoadTable();
    }
    const onBack = () => {
        showMain.value = true;
        showSetting.value = false;
    }
    const onDialogOpen = () => {
        if (addOrEdit.value == 'edit') {
            nextTick(() => {
                form.value = formData.value;
            })
        }
    }

    const onAddClick = () => {
        IDdisabled.value = false;
        addOrEdit.value = 'add';
        dialogFormVisible.value = true;
        dialogTitle.value = '新增角色';

        nextTick(() => {
            formRef.value.resetFields();
        })
    }

    const onCopyClick = () => {
        IDdisabled.value = false;
        addOrEdit.value = 'copy';
        dialogFormVisible.value = true;
        dialogTitle.value = '將角色' + setForm.value.ROLE_CHI_NAME + '功能權限複製到';

        nextTick(() => {
            formRef.value.resetFields();
        })
    }

    const onEditClick = (e, cell) => {
        formData.value = JSON.parse(JSON.stringify(cell.getData()));

        IDdisabled.value = true;
        addOrEdit.value = 'edit';
        dialogFormVisible.value = true;
        dialogTitle.value = '編輯角色';
    }

    const onEditRoleClick = (e, cell) => {
        setForm.value = cell.getData();
        showMain.value = false;
        showSetting.value = true;
        onLoadSetTable();
    }

    const onDeleteClick = (e, cell) => {
        ElMessageBox.confirm('確定要刪除?', '提示', {
            confirmButtonText: '確認',
            cancelButtonText: '取消',
            type: 'warning',
        }).then(() => {
            $api.POST('/api/BaseRole/Delete', cell.getData()
            ).then((res) => {
                if (res == -2) {
                    ElMessageBox.alert('本作業角色使用中, 不可刪除!', '提示', {
                        confirmButtonText: '確定'
                    });
                } else {
                    ElMessageBox.alert('刪除成功!', '提示', {
                        confirmButtonText: '確定',
                        callback: action => {
                            onLoadTable();
                        }
                    });
                }
            })
        });
    }

    const onSubmit = () => {
        formRef.value.validate((valid) => {
            if (valid) {
                if (addOrEdit.value == 'add') {
                    $api.POST('/api/BaseRole/Add', form.value
                    ).then((res) => {
                        if (res == -2) {
                            ElMessageBox.alert('已存在相同角色代碼，不可新增', '提示', {
                                confirmButtonText: '確定'
                            });
                        } else {
                            ElMessageBox.alert('新增成功!', '提示', {
                                confirmButtonText: '確定',
                                callback: action => {
                                    dialogFormVisible.value = false;
                                    onLoadTable();
                                }
                            });
                        }
                    })
                } else if (addOrEdit.value == 'copy') {
                    $api.POST('/api/BaseRole/Add', form.value
                    ).then((res) => {
                        if (res == -2) {
                            ElMessageBox.alert('已存在相同角色代碼，不可新增', '提示', {
                                confirmButtonText: '確定'
                            });
                        } else {
                            var data = tabulator_set.value.getData();
                            $api.POST('/api/SysFuncRole/Save', {
                                COMP_ID: form.value.COMP_ID, ROLE_ID: form.value.ROLE_ID, tableData: data
                            }).then((res) => {
                                ElMessageBox.alert('儲存成功!', '提示', {
                                    confirmButtonText: '確定',
                                    callback: action => {
                                        dialogFormVisible.value = false;
                                        onLoadTable();
                                        onBack();
                                    }
                                });
                            });
                        }
                    })
                } else {
                    $api.POST('/api/BaseRole/Edit', form.value,
                    ).then((res) => {
                        ElMessageBox.alert('編輯成功!', '提示', {
                            confirmButtonText: '確定',
                            callback: action => {
                                dialogFormVisible.value = false;
                                onLoadTable();
                            }
                        });
                    })
                }
            }
        })
    }

    const onSetSubmit = () => {
        var data = tabulator_set.value.getData();
        $api.POST('/api/SysFuncRole/Save', {
            COMP_ID: setForm.value.COMP_ID, ROLE_ID: setForm.value.ROLE_ID, tableData: data
        }).then((res) => {
            ElMessageBox.alert('儲存成功!', '提示', {
                confirmButtonText: '確定',
                callback: action => {
                    onBack();
                }
            });
        });
    }

    const editIcon = (cell, formatterParams) => {
        return '<i class="el-icon"><svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path d="m199.04 672.64 193.984 112 224-387.968-193.92-112-224 388.032zm-23.872 60.16 32.896 148.288 144.896-45.696L175.168 732.8zM455.04 229.248l193.92 112 56.704-98.112-193.984-112-56.64 98.112zM104.32 708.8l384-665.024 304.768 175.936L409.152 884.8h.064l-248.448 78.336L104.32 708.8zm384 254.272v-64h448v64h-448z" fill="currentColor"></path></svg></i>';
    }
    const deleteIcon = (cell, formatterParams) => {
        return '<i class="el-icon"><svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M352 192V95.936a32 32 0 0 1 32-32h256a32 32 0 0 1 32 32V192h256a32 32 0 1 1 0 64H96a32 32 0 0 1 0-64h256zm64 0h192v-64H416v64zM192 960a32 32 0 0 1-32-32V256h704v672a32 32 0 0 1-32 32H192zm224-192a32 32 0 0 0 32-32V416a32 32 0 0 0-64 0v320a32 32 0 0 0 32 32zm192 0a32 32 0 0 0 32-32V416a32 32 0 0 0-64 0v320a32 32 0 0 0 32 32z"></path></svg></i>';
    }

    const ckParams = (cell) => {
        //如果是第一階層(ID後三碼是000)，則不會有勾選框
        if (cell.getRow().getData().FUNC_ID.substring(1, 4) == '000') {
            return {
                tickElement: '',
                crossElement: '',
            };
        }
        if (cell.getValue() == null || cell.getValue() == 'N') {
            cell.setValue(false);
        } else if (cell.getValue() == 'Y') {
            cell.setValue(true);
        }
        //CAN_RUN 對應 SET_RUN
        var col = cell.getField().replace('CAN', 'SET');
        var set = cell.getRow().getData()[col];
        if (set == "Y") {
            return {
                tickElement: '<input type="checkbox" checked/>',
                crossElement: '<input type="checkbox"/>',
            };
        } else {
            if (cell.getValue()) {
                cell.setValue(false);
            }
            return {
                tickElement: '<input type="checkbox" disabled/>',
                crossElement: '<input type="checkbox" disabled/>',
            };
        }
    }

    const ckParams_All = (cell) => {
        //如果是第一階層(ID後三碼是000)，則不會有勾選框
        if (cell.getRow().getData().FUNC_ID.substring(1, 4) == '000') {
            return {
                tickElement: '',
                crossElement: '',
            };
        }
        //處理全選的功能
        var ck = cell.getValue();
        if (cell.getValue() != null) {
            cell.getRow().getCell('CAN_RUN').setValue(ck);
            cell.getRow().getCell('CAN_SEARCH').setValue(ck);
            cell.getRow().getCell('CAN_ADD').setValue(ck);
            cell.getRow().getCell('CAN_MODIFY').setValue(ck);
            cell.getRow().getCell('CAN_DEL').setValue(ck);
            cell.getRow().getCell('CAN_PRINT').setValue(ck);
        }
        return {
            tickElement: '<input type="checkbox" checked />',
            crossElement: '<input type="checkbox" />',
        };
    }

    const ckEdit = (cell) => {
        //如果是第一階層，則不會有勾選框
        //if (cell.getRow().getData().PARENT == '0000') {
        //    return false;
        //}
        var col = cell.getField().replace('CAN', 'SET');
        var set = cell.getRow().getData()[col];
        if (set == 'Y') {
            return true;
        } else {
            return false;
        }
    }

    const ckEdit_All = (cell) => {
        //如果是第一階層(ID後三碼是000)，則不會有勾選框
        if (cell.getRow().getData().FUNC_ID.substring(1, 4) == '000') {
            return false;
        } else {
            return true;
        }
    }

    const getOptions = async () => {
        $api.GET('/api/Outlet/GetCompOptions', {
            CUST_CODE: localStorage.getItem('CustCode')
        }).then((response) => {
            compOptions.value = response;
        })
    };

    onBeforeMount(() => {
        //options
        getOptions();
        if (localStorage.getItem("VendorType") == "門店") {
            Roledisabled.value = true;
        }
    });

    onMounted(() => {
        onLoadTable();

        //instantiate Tabulator when element is mounted
        tabulator.value = new Tabulator(table.value, {
            locale: "zh-tw",
            layout: "fitColumns",      //fit columns to width of table
            maxHeight: "100%", //do not let table get bigger than the height of its parent element
            columnHeaderVertAlign: "middle", //align header contents to middle of cell
            pagination: true,       //paginate the data
            paginationSize: 50,         //allow 50 rows per page of data
            paginationSizeSelector: [50, 100, 200],
            columns: [
                { title: "No", formatter: "rownum", headerHozAlign: "center", hozAlign: "center", headerSort: false, width: 50 },
                { title: "公司代號", field: "COMP_ID", headerHozAlign: "center", hozAlign: "center", headerSort: false },
                { title: "群組/角色代號", field: "ROLE_ID", headerHozAlign: "center", hozAlign: "center", headerSort: false },
                { title: "群組/角色名稱", field: "ROLE_CHI_NAME", headerHozAlign: "center", hozAlign: "center", headerSort: false },
                { title: "公用", field: "PUBLIC_FG", headerHozAlign: "center", hozAlign: "center", maxWidth: 150, headerSort: false, width: 90 },
                {
                    title: "狀態", field: "ACT_FG", headerHozAlign: "center", hozAlign: "center", maxWidth: 150, headerSort: false, width: 90,
                    formatter: function (cell, formatterParams, onRendered) {
                        if (cell.getValue() == "Y") {
                            return "啟用";
                        } else if (cell.getValue() == "N") {
                            return "停用";
                        }
                    }
                },
                { title: "編輯", field: "edit", formatter: editIcon, headerHozAlign: "center", hozAlign: "center", headerSort: false, width: 50, cellClick: onEditClick },
                { title: "權限", field: "edit", formatter: editIcon, headerHozAlign: "center", hozAlign: "center", headerSort: false, width: 50, cellClick: onEditRoleClick },
                { title: "刪除", field: "delete", formatter: deleteIcon, headerHozAlign: "center", hozAlign: "center", headerSort: false, width: 50, cellClick: onDeleteClick },
            ],
            langs: {
                "zh-tw": {
                    "pagination": {
                        "page_size": "選擇筆數",
                        "first": "第一頁",
                        "last": "最後一頁",
                        "prev": "上一頁",
                        "next": "下一頁",
                    }
                }
            },
        });
        tabulator.value.on("tableBuilt", function () {
            if (!store.getters.check_auth('MODIFY')) {
                tabulator.value.hideColumn('edit');
            }
            if (!store.getters.check_auth('DEL')) {
                tabulator.value.hideColumn('delete');
            }
        });

        //權限樹狀表格
        tabulator_set.value = new Tabulator(table_set.value, {
            layout: "fitColumns",      //fit columns to width of table
            maxHeight: "100%", //do not let table get bigger than the height of its parent element
            pagination: false,       //paginate the data
            movableColumns: true,      //allow column order to be changed
            dataTree: true,
            dataTreeStartExpanded: true,
            initialSort: [             //set the initial sort order of the data
                { column: "FUNC_ID", dir: "asc" },
            ],
            columns: [                 //define the table columns
                { title: "功能名稱", field: "CHI_DESC", headerHozAlign: "center", hozAlign: "left", headerSort: false },
                { title: "功能", field: "FUNC_ID", headerHozAlign: "center", hozAlign: "left", headerSort: false },
                { title: "執行", field: "CAN_RUN", headerHozAlign: "center", hozAlign: "center", maxWidth: 150, headerSort: false, formatter: "tickCross", editor: true, editable: ckEdit, formatterParams: ckParams },// , editable: ckEdit, formatterParams: ckParams
                { title: "查詢", field: "CAN_SEARCH", headerHozAlign: "center", hozAlign: "center", maxWidth: 150, headerSort: false, formatter: "tickCross", editor: true, editable: ckEdit, formatterParams: ckParams },
                { title: "新增", field: "CAN_ADD", headerHozAlign: "center", hozAlign: "center", maxWidth: 150, headerSort: false, formatter: "tickCross", editor: true, editable: ckEdit, formatterParams: ckParams },
                { title: "編輯", field: "CAN_MODIFY", headerHozAlign: "center", hozAlign: "center", maxWidth: 150, headerSort: false, formatter: "tickCross", editor: true, editable: ckEdit, formatterParams: ckParams },
                { title: "刪除", field: "CAN_DEL", headerHozAlign: "center", hozAlign: "center", maxWidth: 150, headerSort: false, formatter: "tickCross", editor: true, editable: ckEdit, formatterParams: ckParams },
                { title: "列印", field: "CAN_PRINT", headerHozAlign: "center", hozAlign: "center", maxWidth: 150, headerSort: false, formatter: "tickCross", editor: true, editable: ckEdit, formatterParams: ckParams },
                { title: "全選", field: null, headerHozAlign: "center", hozAlign: "center", maxWidth: 150, headerSort: false, formatter: "tickCross", editor: true, editable: ckEdit_All, formatterParams: ckParams_All },
            ]
        });
    })

</script>

<style></style>
